import {IObjectData} from "../../../index";
import {nsUserSyncfields} from "@component/user/syncfields/nsUserSyncfields";
import {TSyncfield_User} from "../../../constants/Syncfields";
import {getRawSyncFieldValue} from "../../../util/misc";
import view_listHtml from './view-list.html?raw';

export const template = view_listHtml;

interface IViewListParams {
    object: IObjectData
    def: nsUserSyncfields.ICard
}

export class viewModel {
    private object: IObjectData
    private def: nsUserSyncfields.ICard

    constructor(params: IViewListParams) {
        this.object = params.object
        this.def = params.def
    }

    protected shouldShow(): boolean {
        return nsUserSyncfields.shouldShow(this.def, this.object)
    }

    protected shouldShowSyncfield(syncfield: TSyncfield_User): boolean {
        return this.def.optional?.includes(syncfield)
            ? !!getRawSyncFieldValue(syncfield, this.object.syncfields)
            : true
    }
}
